import React from 'react';
import Header from '../components/header'
import Footer from '../components/footer';
import ServicesComponent from '../components/services';
import { VerticalSeparator, LineSeparator } from '../components/separators';
import AreYouInterestedComponent from '../components/areYouInterestedComponent.js';
import FotoProfilo from '../photos/Case/Facciata/esterno piano terra 3_sfondo_verticale.jpg'
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect } from 'react';
import GalleryComponent from '../components/galleryWrapper.js';
import DataHousePage1 from '../galleries/data/dataHousePage1.ts';
import PetIcon from '../icons/pet_friendly.png';
import NoSmokingIcon from '../icons/no_smoking.png';
import './housePage.css';

const House1Page = (props) => {

  const { selectedLanguage, handleLanguageChange } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />

      <Container fluid style={{ width: '100%' }}>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <h1 className='text-h-housepage-class' style={{ textAlign: 'center' }}>{selectedLanguage === 'ita' ? "Piano Terra" : "Ground Floor"}</h1>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <Row>
          <Col md={6} style={{ alignContent: 'center' }}>
            <img src={FotoProfilo} alt="" className="img-fluid" style={{ width: '100%', height: '100%', maxHeight: '1000px', borderRadius: '12px', objectFit: 'cover' }} />
          </Col>
          <Col md={6}>
            <div style={{ textAlign: 'justify', marginLeft: '10px', marginRight: '10px' }}>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
              <p className='text-p-housepage-class'>
                {selectedLanguage === 'ita' ? "L’appartamento al piano terra è circondato da un giardino sempre verde ed ha sul retro una grande veranda attrezzata con cucina, barbecue, lavello, tavolo e salottino. Questo appartamento è perfetto anche per i vostri amici a quattro zampe perché possono tranquillamente stare in veranda senza possibilità di fuga." : "The ground floor apartment is surrounded by a constantly green garden and has a large veranda at the back equipped with a kitchen, barbecue, sink, table, and lounge area. This apartment is also perfect for your four-legged friends as they can comfortably stay on the veranda without any chance of escape."}
                <br />
                <br />
                {selectedLanguage === 'ita' ? "Per la vicinanza col mare e per le attrezzature che possono essere fornite (lettini da campeggio, passeggini, seggioloni, etc.), è ideale anche per famiglie con bambini anche molto piccoli al seguito." : "For its proximity to the sea and the equipment that can be provided (camping cots, strollers, high chairs, etc.), it is also ideal for families with very young children."}
                <br />
                <br />
                {selectedLanguage === 'ita' ? "L’appartamento ha due camere da letto (una con letto matrimoniale l'altra con due letti eventualmente trasformabile in matrimoniale) un ampio e confortevole soggiorno con divano letto. La cucina è attrezzata di tutti gli utensili necessari al suo uso quotidiano. Il servizio è con doccia. L'appartamento è dotato di TV, lavabiancheria, aria Condizionata e WiFi." : "The apartment has two bedrooms (one with a double bed, the other with two beds potentially convertible into a double), a spacious and comfortable living room with a sofa bed. The kitchen is equipped with all the utensils necessary for daily use. The bathroom has a shower. The apartment is equipped with TV, washing machine, air conditioning, and WiFi."}
                <br />
                <br />
                {selectedLanguage === 'ita' ? "A pochi passi troverete supermercati, ristoranti, pizzerie e bar con accanto area giochi all’aperto per bambini." : "A few steps away, you will find supermarkets, restaurants, pizzerias, and bars with outdoor play areas for children."}
                <br />
              </p>
              <div>
                <img src={NoSmokingIcon} alt='' className='text-i-housepage-class' style={{ width: '4vw', height: '4vw', marginRight: '10px' }} />
                <span className='text-p-housepage-class'>{selectedLanguage === 'ita' ? "Divieto di fumo nei locali interni" : "Smoking ban in internal spaces"}</span>
              </div>
              <div>
                <img src={PetIcon} alt='' className='text-i-housepage-class' style={{ width: '4vw', height: '4vw', marginRight: '10px' }} />
                <span className='text-p-housepage-class'>{selectedLanguage === 'ita' ? "Animali consentiti" : "Pet allowed"}</span>
              </div>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
            </div>
          </Col>
        </Row>
      </Container>

      <LineSeparator></LineSeparator>

      <ServicesComponent selectedLanguage={selectedLanguage} ></ServicesComponent>

      <LineSeparator></LineSeparator>

      <AreYouInterestedComponent selectedLanguage={selectedLanguage} ></AreYouInterestedComponent>

      <LineSeparator></LineSeparator>

      <GalleryComponent text={selectedLanguage === 'ita' ? "Galleria" : "Gallery"} DataHousePage1={DataHousePage1}></GalleryComponent>

      <Footer />
    </>
  );
}

export default House1Page;
